import { getToken } from "firebase/app-check";

// Server za sada samo BELEŽI validnost App Check tokena (ne odbija zahteve),
// pa neuspeh uzimanja tokena NIKAD ne sme da obori zahtev — vraća se null i
// zahtev ide bez headera. Instancu registruje FirebaseContext posle
// initializeApp (samo ako je REACT_APP_APPCHECK_SITE_KEY postavljen).

let appCheckInstance = null;

export function setAppCheckInstance(instance) {
    appCheckInstance = instance;
}

export async function getAppCheckToken() {
    if (!appCheckInstance) return null;
    try {
        const { token } = await getToken(appCheckInstance, false);
        return token || null;
    } catch (e) {
        return null;
    }
}
